import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_SPECIALTIES,
  CREATE_SPECIALTIES,
  UPDATE_SPECIALTIES,
  DELETE_SPECIALTIES,
} from "./actionType";

import {
  SpecialtiesApiResponseSuccess,
  SpecialtiesApiResponseError,
} from "./action";

import {
  getSpecialties as getSpecialty,
  createSpecialties as createSpecialty,
  updateSpecialties as updateSpecialty,
  deleteSpecialties as deleteSpecialty,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";
import { notifyError, notifySuccess } from "../../components/notify";

function* getSpecialties() {
  try {
    const response = yield call(getSpecialty);
    yield put(SpecialtiesApiResponseSuccess(GET_SPECIALTIES, response));
  } catch (error) {
    yield put(SpecialtiesApiResponseError(GET_SPECIALTIES, error));
  }
}

function* createSpecialties(data) {
  try {
    const response = yield call(createSpecialty, data.payload.data);
    yield put(SpecialtiesApiResponseSuccess(CREATE_SPECIALTIES, response));
    notifySuccess("Especialidade adicionada com sucesso!");
  } catch (error) {
    yield put(SpecialtiesApiResponseError(CREATE_SPECIALTIES, error));
    notifyError("Erro ao adicionar especialidade!");
  }
}

function* updateSpecialties(data) {
  try {
    const response = yield call(updateSpecialty, data.payload.data);
    yield put(SpecialtiesApiResponseSuccess(UPDATE_SPECIALTIES, response));
    notifySuccess("Especialidade atualizada com sucesso!");
  } catch (error) {
    yield put(SpecialtiesApiResponseError(UPDATE_SPECIALTIES, error));
    notifyError("Erro ao deletar especialidade!");
  }
}

function* deleteSpecialties(data) {
  try {
    const response = yield call(deleteSpecialty, data.payload.id);
    yield put(SpecialtiesApiResponseSuccess(DELETE_SPECIALTIES, response));
    notifySuccess("Especialidade deletada com sucesso!");
  } catch (error) {
    yield put(SpecialtiesApiResponseError(DELETE_SPECIALTIES, error));
    notifyError("Erro ao deletar especialidade!");
  }
}

export function* watchGetSpecialties() {
  yield takeEvery(GET_SPECIALTIES, getSpecialties);
}

export function* watchCreateSpecialties() {
  yield takeEvery(CREATE_SPECIALTIES, createSpecialties);
}

export function* watchUpdateSpecialties() {
  yield takeEvery(UPDATE_SPECIALTIES, updateSpecialties);
}

export function* watchDeleteSpecialties() {
  yield takeEvery(DELETE_SPECIALTIES, deleteSpecialties);
}

function* SpecialtiesSaga() {
  yield all([fork(watchGetSpecialties)]);
  yield all([fork(watchCreateSpecialties)]);
  yield all([fork(watchUpdateSpecialties)]);
  yield all([fork(watchDeleteSpecialties)]);
}

export default SpecialtiesSaga;
